export default "__VITE_ASSET__DwDxfQfv__"